import { Vue, Component, Prop } from 'vue-property-decorator'
import APP_CONST from '@/constants/AppConst'

@Component({
  name: 'element-label',
  components: {}
})
export default class ElementLabelComponent extends Vue {
  APP_CONST = APP_CONST

  @Prop()
  element!: any

  @Prop()
  selectWidget!: any

  mounted() {}

  updateLabel(element: any) {
    const doc: any = document.getElementById(`label-${element.key}`)
    this.$emit('updateLabel', { doc: doc.innerText.trim(), element: element })
  }
}
